import BaseModelInstance from './base.model'
import { UserContractRequest as ModelDefinition } from './model-definitions'

class UserContractRequest extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserContractRequest
